import http from '@/utils/http';
const base_path = '/v2/tool/advertiserSourceTemplate';

/**
 * 获取资源模板列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function getAdvertiserSourceTemplateListApi(params) {
  return http.get({
    url: base_path,
    params,
  });
}

/**
 * 获取资源模板详情接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function getAdvertiserSourceTemplateDetailApi(params, id) {
  return http.get({
    url: `${base_path}/${id}`,
    params,
  });
}

/**
 * 新建资源模板接口
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const addAdvertiserSourceTemplateApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 编辑资源模板接口
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const editAdvertiserSourceTemplateApi = (data, id) => {
  return http.put({
    url: `${base_path}/${id}`,
    data,
  });
};

/**
 * 删除资源模板
 * @param {Object} data 请求参数
 * @returns {Promise<Object>}
 */
export const delAdvertiserSourceTemplateApi = (data, id) => {
  return http.delete({
    url: `${base_path}/${id}`,
    data,
  });
};
